<template>
  <div class="leaflet-wrapper">
    <l-map :center="center" :maxZoom="maxZoom" :minZoom="minZoom" :options="mapOptions" :zoom="zoom"
           @ready="prepareStyle">
      <l-marker
        :icon="getIcon(marker.acf.place_cat, marker.acf.place_type)"
        :key="marker.id"
        :lat-lng.sync="marker.acf.place_geoloc"
        :visible="marker.visible"
        @click="goToPlace(marker)"
        v-for="marker in markers"
        v-if="marker.acf.place_geoloc && Object.keys(marker.acf.place_geoloc).length !== 0">
        <l-tooltip :key="marker.id">
          <span class="color-band"></span>
          <div>
            <p v-html="marker.title.rendered" v-if="marker.title.rendered"></p>
            <p v-if="marker.acf.place_geoloc.address"> {{marker.acf.place_geoloc.address}}</p>
          </div>
        </l-tooltip>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
  require('mapbox-gl-leaflet')
  import {icon} from "leaflet";

  import {
    LMap,
    LMarker,
    LTooltip,
  } from "vue2-leaflet";


  const tileProviders = [
    {
      name: "OpenStreetMap",
      visible: true,
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    },
  ];

  export default {
    name: 'theMap',
    components: {
      LMap,
      LMarker,
      LTooltip,
    },
    data() {
      return {
        center: [43.3663209, 2.4211048],
        opacity: 0.6,
        token: "not needed",
        url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
        mapOptions: {
          dragging: true,
          zoomControl: true,
          attributionControl: false,
          attributions: tileProviders.attribution,
          zoomSnap: false,
          style: 'https://api.maptiler.com/maps/eb73b15e-6631-4ca8-96a8-9dd4f10cbaf5/style.json?key=LhcR6rAl2H6jsNiBdG9J'
        },
        zoom: 5,
        minZoom: 5,
        maxZoom: 8,
        zoomPosition: "topleft",
        attributionPosition: "bottomright",
        layersPosition: "topright",
        attributionPrefix: "Vue2Leaflet",
        imperial: false,
        Positions: ["topleft", "topright", "bottomleft", "bottomright"],
        tileProviders: tileProviders
      }
    },
    methods: {
      getIcon(cat, type) {
        if (cat === 'commerce') {
          if (type === 'project') {
            return icon({
              iconUrl: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPjxnPjxnPgoJPGc+CgkJPHBhdGggZD0iTTI1NiwxMjBjLTMzLjA5MSwwLTYwLDI2LjkwOS02MCw2MGMwLDMzLjI0OSwyNi44NjEsNjAsNjAsNjBjMzMuNzMzLDAsNjAtMjcuMjU1LDYwLTYwQzMxNiwxNDYuOTA5LDI4OS4wOTEsMTIwLDI1NiwxMjB6ICAgICIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0VFOEY3MiIvPgoJPC9nPgo8L2c+PGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMjU2LDBDMTU2Ljc0MiwwLDc2LDgwLjc0Miw3NiwxODBjMCwzMy41Myw5LjI4Nyw2Ni4yNTUsMjYuODUxLDk0LjY0NGwxNDIuODk2LDIzMC4yNTkgICAgYzUuOTI1LDkuNTY5LDE5Ljg5NSw5LjQyMywyNS42MzUtMC4yMDVMNDEwLjYzLDI3Mi4yMTJDNDI3LjIxMSwyNDQuNDI0LDQzNiwyMTIuNTM0LDQzNiwxODBDNDM2LDgwLjc0MiwzNTUuMjU4LDAsMjU2LDB6ICAgICBNMjU2LDI3MC4yYy01MC4zNDUsMC05MC4yLTQwLjk3OS05MC4yLTkwLjJjMC00OS42MjksNDAuNTcxLTkwLjIsOTAuMi05MC4yczkwLjIsNDAuNTcxLDkwLjIsOTAuMiAgICBDMzQ2LjIsMjI4Ljc4NywzMDYuODgxLDI3MC4yLDI1NiwyNzAuMnoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiIGZpbGw9IiNFRThGNzIiLz4KCTwvZz4KPC9nPjwvZz4gPC9zdmc+Cg==',
              iconSize: [16, 20],
              iconAnchor: [6, 20],
            })
          } else {
            return icon({
              iconUrl: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPjxnPjxnPgoJPGc+CgkJPHBhdGggZD0iTTI1NiwxMjBjLTMzLjA5MSwwLTYwLDI2LjkwOS02MCw2MGMwLDMzLjI0OSwyNi44NjEsNjAsNjAsNjBjMzMuNzMzLDAsNjAtMjcuMjU1LDYwLTYwQzMxNiwxNDYuOTA5LDI4OS4wOTEsMTIwLDI1NiwxMjB6ICAgICIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0NCNjE0MCIvPgoJPC9nPgo8L2c+PGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMjU2LDBDMTU2Ljc0MiwwLDc2LDgwLjc0Miw3NiwxODBjMCwzMy41Myw5LjI4Nyw2Ni4yNTUsMjYuODUxLDk0LjY0NGwxNDIuODk2LDIzMC4yNTkgICAgYzUuOTI1LDkuNTY5LDE5Ljg5NSw5LjQyMywyNS42MzUtMC4yMDVMNDEwLjYzLDI3Mi4yMTJDNDI3LjIxMSwyNDQuNDI0LDQzNiwyMTIuNTM0LDQzNiwxODBDNDM2LDgwLjc0MiwzNTUuMjU4LDAsMjU2LDB6ICAgICBNMjU2LDI3MC4yYy01MC4zNDUsMC05MC4yLTQwLjk3OS05MC4yLTkwLjJjMC00OS42MjksNDAuNTcxLTkwLjIsOTAuMi05MC4yczkwLjIsNDAuNTcxLDkwLjIsOTAuMiAgICBDMzQ2LjIsMjI4Ljc4NywzMDYuODgxLDI3MC4yLDI1NiwyNzAuMnoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiIGZpbGw9IiNDQjYxNDAiLz4KCTwvZz4KPC9nPjwvZz4gPC9zdmc+Cg==',
              iconSize: [16, 20],
              iconAnchor: [6, 20],
            })
          }
        } else {
          if (type === 'project') {
            return icon({
              iconUrl: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPjxnPjxnPgoJPGc+CgkJPHBhdGggZD0iTTI1NiwxMjBjLTMzLjA5MSwwLTYwLDI2LjkwOS02MCw2MGMwLDMzLjI0OSwyNi44NjEsNjAsNjAsNjBjMzMuNzMzLDAsNjAtMjcuMjU1LDYwLTYwQzMxNiwxNDYuOTA5LDI4OS4wOTEsMTIwLDI1NiwxMjB6ICAgICIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0VBQjY1OSIvPgoJPC9nPgo8L2c+PGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMjU2LDBDMTU2Ljc0MiwwLDc2LDgwLjc0Miw3NiwxODBjMCwzMy41Myw5LjI4Nyw2Ni4yNTUsMjYuODUxLDk0LjY0NGwxNDIuODk2LDIzMC4yNTkgICAgYzUuOTI1LDkuNTY5LDE5Ljg5NSw5LjQyMywyNS42MzUtMC4yMDVMNDEwLjYzLDI3Mi4yMTJDNDI3LjIxMSwyNDQuNDI0LDQzNiwyMTIuNTM0LDQzNiwxODBDNDM2LDgwLjc0MiwzNTUuMjU4LDAsMjU2LDB6ICAgICBNMjU2LDI3MC4yYy01MC4zNDUsMC05MC4yLTQwLjk3OS05MC4yLTkwLjJjMC00OS42MjksNDAuNTcxLTkwLjIsOTAuMi05MC4yczkwLjIsNDAuNTcxLDkwLjIsOTAuMiAgICBDMzQ2LjIsMjI4Ljc4NywzMDYuODgxLDI3MC4yLDI1NiwyNzAuMnoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiIGZpbGw9IiNFQUI2NTkiLz4KCTwvZz4KPC9nPjwvZz4gPC9zdmc+Cg==',
              iconSize: [16, 20],
              iconAnchor: [6, 20],
            })
          } else {
            return icon({
              iconUrl: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPjxnPjxnPgoJPGc+CgkJPHBhdGggZD0iTTI1NiwxMjBjLTMzLjA5MSwwLTYwLDI2LjkwOS02MCw2MGMwLDMzLjI0OSwyNi44NjEsNjAsNjAsNjBjMzMuNzMzLDAsNjAtMjcuMjU1LDYwLTYwQzMxNiwxNDYuOTA5LDI4OS4wOTEsMTIwLDI1NiwxMjB6ICAgICIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0ZBRDM4QyIvPgoJPC9nPgo8L2c+PGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMjU2LDBDMTU2Ljc0MiwwLDc2LDgwLjc0Miw3NiwxODBjMCwzMy41Myw5LjI4Nyw2Ni4yNTUsMjYuODUxLDk0LjY0NGwxNDIuODk2LDIzMC4yNTkgICAgYzUuOTI1LDkuNTY5LDE5Ljg5NSw5LjQyMywyNS42MzUtMC4yMDVMNDEwLjYzLDI3Mi4yMTJDNDI3LjIxMSwyNDQuNDI0LDQzNiwyMTIuNTM0LDQzNiwxODBDNDM2LDgwLjc0MiwzNTUuMjU4LDAsMjU2LDB6ICAgICBNMjU2LDI3MC4yYy01MC4zNDUsMC05MC4yLTQwLjk3OS05MC4yLTkwLjJjMC00OS42MjksNDAuNTcxLTkwLjIsOTAuMi05MC4yczkwLjIsNDAuNTcxLDkwLjIsOTAuMiAgICBDMzQ2LjIsMjI4Ljc4NywzMDYuODgxLDI3MC4yLDI1NiwyNzAuMnoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiIGZpbGw9IiNGQUQzOEMiLz4KCTwvZz4KPC9nPjwvZz4gPC9zdmc+Cg==',
              iconSize: [16, 20],
              iconAnchor: [6, 20],
            })
          }
        }
      },
      prepareStyle(map) {
        map.zoomControl.setPosition('bottomleft')
        map.scrollWheelZoom.disable();
        L.mapboxGL({
          style: 'https://api.maptiler.com/maps/eb73b15e-6631-4ca8-96a8-9dd4f10cbaf5/style.json?key=LhcR6rAl2H6jsNiBdG9J',
          accessToken: 'pk.eyJ1IjoidGVkamZlcmhhdGkiLCJhIjoiY2syMDdsejRtMDB0ZTNvcXpienl1Z2ZoYyJ9.NfFZPsKLm5ygPsb7XaIdYA'
        }).addTo(map);
      },
      goToPlace(marker) {
        location.href = marker.link
      }
    },
    computed: {
      markers() {
        return this.$root.filteredPlaces ? this.$root.filteredPlaces : []
      }
    }
  }
</script>

<style lang="scss">
  .leaflet-wrapper {
    height: 660px;
    width: 100%;

    @media (max-width: 1025px) {
      height: 550px
    }
  }

  .leaflet-control-zoom {
    top: 50%;
  }

  .color-band {
    height: calc(100% + 2px);
    width: 10px;
    position: absolute;
    top: -1px;
    left: -1px;
    background-color: #CB6140;
  }

  .leaflet-pane.leaflet-tooltip-pane > div {
    padding: 10px 20px;

    p {
      margin: 0;
      font-size: 16px;
      line-height: 1.5;

      &:first-child {
        font-weight: 700;
      }
    }
  }
</style>
